import Service from '../service/Service';
const service = new Service();
import Cookies from "js-cookie";

export function shareOn(id) {
    // debugger;
    let ary = document.getElementsByClassName('sharing-options');
    for (let i = 0; i < ary.length; i++) {
        ary[i].style.display = 'none';
    }
    document.getElementById('share_' + id).getElementsByClassName('sharing-options')[0].style.display = 'block';
    if (window.innerWidth < 767) {
        if (document.getElementsByClassName('share-overlay')[0]) {
            document.getElementsByClassName('share-overlay')[0].style.display = 'block';
        }
    }
}

export function shareArticle(shareoption, articleurl) {
    console.log("articleurl :",articleurl);
    var shareurl;
    if (!articleurl.includes('http')) {
        articleurl = 'https:' + articleurl;
    }
    let ary = document.getElementsByClassName('sharing-options');
    for (let i = 0; i < ary.length; i++) {
        ary[i].style.display = 'none';
    }
    if (document.getElementsByClassName('share-overlay')[0]) {
        document.getElementsByClassName('share-overlay')[0].style.display = 'none';
    }
    if (shareoption == "facebook") {
        shareurl = 'https://www.facebook.com/sharer/sharer.php?u=';
    } else if (shareoption == "twitter") {
        shareurl = 'https://twitter.com/share?url=';
    } else if (shareoption == "pintrest") {
        shareurl = 'https://www.pinterest.com/pin/create/button/?url=';
    } else if (shareoption == "whatsapp") {
        shareurl = 'whatsapp://send?text=';
    }
    var sharewindow = window.open(shareurl + articleurl, shareoption + '-popup', 'height=350,width=600');
    if (sharewindow.focus) {
        sharewindow.focus();
    }
    return false;
}

export function domClick(event) {
    // debugger;
    if (!event.target.classList.contains('share-btn')) {
        // let ary = document.getElementsByClassName('sharing-options');
        // for (let i = 0; i < ary.length; i++) {
        //     ary[i].style.display = 'none';
        // }
        document.getElementsByClassName('sharing-options')[0].style.display = 'none';
        if (document.getElementsByClassName('share-overlay')[0]) {
            document.getElementsByClassName('share-overlay')[0].style.display = 'none';
        }
    }
}

export function closeFilter() {
    document.querySelector(".filter-overlay").style.display = "none";
}
export function openFilter() {
    document.querySelector(".category-filter-overlay").style.display = "none";
    document.querySelector(".filter-overlay").style.display = "block";
}
export function openCatgFilter(eleRef) {
    eleRef.setState({ filterSearchVal: '' }); 
    document.querySelector("#categoryFilterText").value = "";
    document.querySelector(".category-filter-overlay").style.display = "block";
}
export function closeCatgFilter() {
    document.querySelector(".category-filter-overlay").style.display = "none";
}

export function nextSlide(e) {
    var mainEle = e.currentTarget.parentElement;
    var eachSlide = mainEle.children[0].children[0].children[0];
    var scrolllft = eachSlide.offsetWidth + parseInt(window.getComputedStyle(eachSlide).marginRight);
    mainEle.children[0].scrollLeft += scrolllft;
}
export function prevSlide(e) {
    var mainEle = e.currentTarget.parentElement;
    var eachSlide = mainEle.children[0].children[0].children[0];
    var scrolllft = eachSlide.offsetWidth + parseInt(window.getComputedStyle(eachSlide).marginRight);
    mainEle.children[0].scrollLeft -= scrolllft;
}

export function selectDeskCat(list, eleRef) {
    if (eleRef.state.page == "ColouringPageLanding") {
        var selectedCatAry = eleRef.state.initialData.filter(function (item) {
            return item.categoryId == list.categoryId;
        });
        eleRef.setState({
            selectedDeskCat: list.categoryName,
            selectedCatAry: selectedCatAry
        })
        gotoCatDetail(list.categoryId,list.isSubCatData);
    } else if (eleRef.state.page == "ColoringCatDetails") {
        gotoCatDetail(list.categoryId,list.isSubCatData);
    }
}

export function gotoCatDetail(categoryId,isSubCatData) {
    if(isSubCatData == 1){
        window.location.href = service.getRedirectUrl("/coloring-pages-printables/" + categoryId+"/");
    }else{
        return false;
    }
}


export function gotoSubCatDetail(categoryName, categoryId,eleRef,flag) {
    if(flag==1){
        if (eleRef.state.page == "ColoringSubCatDetails") {
            window.location.href = service.getRedirectUrl("/coloring-pages-printables/details/"+ categoryId);
        }else{
            window.location.href = service.getRedirectUrl("/coloring-pages-printables/"+categoryName+"/"+ categoryId+"/");
        }
    }else{
        window.location.href = service.getRedirectUrl("/coloring-pages-printables/"+categoryName+"/"+ categoryId+"/");
        return false;
    }
     
}

export function gotoSubCatOtherDetail(categoryName, SubcategoryName) {     
        window.location.href = service.getRedirectUrl("/coloring-pages-printables/"+categoryName+"/"+ SubcategoryName+"/");
}

export function gotoOtherSubCatDetail(categoryName) {
        window.location.href = service.getRedirectUrl("/coloring-pages-printables/"+categoryName+"/");
}

export function gotoDetailsPage(mainCat,subCat,cat,id) {
        // window.location.href = service.getRedirectUrl("/coloring-pages-printables/"+mainCat+"/"+subCat+"/"+ cat+"/");
        window.location.href = service.getRedirectUrl("/coloring-pages-printables/image/"+ cat+"-"+id+"/");

}



export function LoadSubcategorylist(categoryId,categoryName,eleRef) {
    // debugger
        eleRef.setState({ filterSearchVal: ''}); 
        document.querySelector(".category-filter-overlay").style.display = "none";
        document.querySelector(".filter-overlay").style.display = "block";
        document.querySelector("#sabcat_search").value = "";
        // document.querySelector("#searchMobile").value = "";
        
        

        var url = global.api_ci_url + "Coloringpages/getsubcategorylist";
        let postData = {
            "categoryName": categoryName && categoryName.replace(/and/g,"&"),
            "pageno": "1",
            "pagesize": "10"
        }
                        

        service.postServiceCall(url, postData).then((json) => {
            if (json['msg'] == "1") {
                
                eleRef.setState({ filterMainCategory: json['result'] });
                eleRef.setState({ filterCategoryId: json['result'][0].subcategoryId });

                
                LoadSubOfSubcategorylist(json['result'][0].subcategoryId,json['result'][0].subcategoryName,eleRef);
                console.log("filterMainCategory ===== ",eleRef.state.filterMainCategory)
                
            }
        }).catch((error) => {
            console.error(error);
        });
}
export function LoadMaincategorylist(e,eleRef,mainCategoryCont) {
    var event = e;
    var pageno = parseInt(mainCategoryCont) + 1;
    // var url = "http://localhost/parenting/Coloringpages/getallmaincategory";
    var url = global.api_ci_url + "Coloringpages/getallmaincategory";
    
    let postData = {
        "pageno": 1,
        "pagesize": 100
    }
                    

    service.postServiceCall(url, postData).then((json) => {
        if (json['msg'] == "1") {
            Cookies.set("mainCategoryCont", pageno);
            // var categoryListArr = eleRef.state.categoryList;
            eleRef.setState({ mainCategoryCont: pageno});   
            // categoryListArr.allCategories[0] = categoryListArr.allCategories[0].concat(json['result'][0].allCategories[0]);
            eleRef.setState({ categoryList: json['result'][0] });
            document.querySelector('.menu-see-more') && (document.querySelector('.menu-see-more').style.display="none");
        }else{
            event.target && (event.target.style.display="none");
            document.querySelector('.menu-see-more') && (document.querySelector('.menu-see-more').style.display="none");
        }
    }).catch((error) => {
        console.error(error);
    });
}
export function  LoadSubOfSubcategorylist(categoryId,categoryName,eleRef) {
        var url = global.api_ci_url + "coloringpages/getsubcategorylist";
        let postData = {
            "categoryName": categoryName && categoryName.replace(/and/g,"&"),
            "pageno": "1",
            "pagesize": "10"
        }
                        

        service.postServiceCall(url, postData).then((json) => {
            if (json['msg'] == "1") {
                
                eleRef.setState({ filterSubCategory: json['result'] });
                eleRef.setState({ filterCategoryId: categoryId });
               // LoadSubOfSubcategorylist(filterMainCategory[0].subcategoryId,filterMainCategory[0].subcategoryName,eleRef);
                console.log("filterSubCategory ===== ",eleRef.state.filterSubCategory)
                
            }
        }).catch((error) => {
            console.error(error);
        });
}

export function  SearchCategorydata(eleRef) {
    if(eleRef.state.filterSearchVal!=""){
        console.log("filterSearchVal====",eleRef.state.filterSearchVal);
        
        var url = global.api_ci_url + "coloringpages/searchcategorylistdata";
        let postData = {
            "categoryName": eleRef.state.filterSearchVal
        }
                        

        service.postServiceCall(url, postData).then((json) => {
            if (json['msg'] == "1") {          
                if(json['result'][0].type=="mainCategory"){
                    window.location.href = service.getRedirectUrl("/coloring-pages-printables/" + service.replaceSymbols(json['result'][0].categoryName)+"/");
                }else if(json['result'][0].type=="subCategory"){
                    window.location.href = service.getRedirectUrl("/coloring-pages-printables/" + service.replaceSymbols(json['result'][0].mainCategory) +"/"+service.replaceSymbols(json['result'][0].categoryName)+"/");
                }else if(json['result'][0].type=="subOfSubCategory"){
                    window.location.href = service.getRedirectUrl("/coloring-pages-printables/" + service.replaceSymbols(json['result'][0].mainCategory) +"/"+service.replaceSymbols(json['result'][0].subCategory)+"/"+service.replaceSymbols(json['result'][0].categoryName)+"/");
                }else{
                    window.location.href = service.getRedirectUrl("/coloring-pages-printables/no-result-found/")    
                }

            }else{
                window.location.href = service.getRedirectUrl("/coloring-pages-printables/no-result-found/")
            }
        }).catch((error) => {
            window.location.href = service.getRedirectUrl("/coloring-pages-printables/no-result-found/")
            console.error(error);
        });


    }else{
        console.log("search val blank");
    }
}

export function  updateSearchInput(event,eleRef) {
    console.log(event.target.value);
     eleRef.setState({ filterSearchVal: event.target.value });        
}

export function readMore(e) {
    if (e.target.innerText == "Read More") {
        e.target.innerText = "Read Less";
        e.target.previousSibling.style.height = "auto";
        e.target.previousSibling.classList.remove("line-clamp");
        e.target.previousSibling.style.display='block';
    }
    else {
        e.target.innerText = "Read More";
        e.target.previousSibling.style.height = "42px";
        e.target.previousSibling.classList.add("line-clamp");
        e.target.previousSibling.style.display='-webkit-box';
    }
}


export function callback(e ,isApp ,urlimg){
    var filename = urlimg.substring(urlimg.lastIndexOf('/')+1);
    var shareUrl =  location.origin + location.pathname;
    var shareText = urlimg ;
    if(isApp){
        if(e == "Download"){
           var deepjson = {
                          "appurl": [
                            {
                              "pagetype": "downloadFile",
                              "url": urlimg,
                              "htmlText": "",
                              "fileName": filename,
                              "message": ""
                            }
                          ]
                        }
               service.jsontracker(JSON.stringify(deepjson));
        }else if(e == "Share"){
           var fname = Math.round(new Date().getTime() / 1000) + "_" + new Date().getTime();
           var deepjson = {
                            "appurl": [
                              {
                                  "pagetype": "share",
                                  "sharepackage": "com.whatsapp",
                                  "shareUrl": shareUrl,
                                  "shareText": shareText,
                                  "thumbnailUrl": ""
                              }

                            ]
                         }
               service.jsontracker(JSON.stringify(deepjson));
        }else if(e == "copyRight"){
                var fname = Math.round(new Date().getTime() / 1000) + "_" + new Date().getTime();
                var deepjson = {
                            "appurl": [
                                {
                                "pagetype": "carnival",
                                "url": "https://parenting.firstcry.com/content-image-usage-policy/?from=app",
                                "webViewTitle":"Content and Image Usage Policy"          
                                } 
                              ]
                            }
                service.jsontracker(JSON.stringify(deepjson));

        }else{
            // return true;
        }
    }else{
        // return true
     }

  }



export function colorImgClick(categoryId, eleRef) {
     gotoCatDetail(categoryId,1);
}
